import { NextSeo } from "next-seo";

import SectionShell from "components/Section-Shell";

import tenets from "elements/Philosophy/listing";
import Tenet from "elements/Philosophy/Item";

const Philosophy = () => {
  return (
    <>
      <NextSeo
        title="The Daisho Philosophy"
        description="Daisho is designed to maximize value from all parts of data."
        canonical="https://www.daisho.ml/vs-auto-ml"
      />
      <SectionShell
        heading="Maximizing VALUE from data"
        subtitle="The Tenets Behind Daisho: Informed by lived experience across
                  the entire Data Science pipeline"
      >
        {tenets.map((t, ind) => (
          <div
            key={ind}
            data-aos="zoom-y-out"
            data-aos-delay={150 + (ind + 1) * 150}
            data-aos-anchor="#philosophy"
          >
            <Tenet tenet={t} index={ind} />
          </div>
        ))}
      </SectionShell>
    </>
  );
};

export default Philosophy;
